export function extractUtmParams(query = {}) {
  const MAX_PARAM_LENGTH = 100
  const dangerousChars = /[<>;"']/g
  const pickFirst = (v) => (Array.isArray(v) ? v[0] : v)
  const sanitize = (v) =>
    String(v).replace(dangerousChars, '').trim().substring(0, MAX_PARAM_LENGTH)

  const allowed = ['source', 'medium', 'campaign', 'term', 'content']

  const utmParams = Object.fromEntries(
    allowed
      .map((k) => {
        const v = query[`utm_${k}`]
        if (v == null) return null
        const clean = sanitize(pickFirst(v))
        return clean ? [k, clean] : null
      })
      .filter(Boolean)
  )

  return utmParams
}
